export default function handleGetDataFromInput(filesFormRef) {
  let files;
  if (filesFormRef.current) {
    files = filesFormRef.current.files;
  } else {
    files = filesFormRef;
  }

  const filesFromInput = [];
  for (let index = 0; index < files.length; index += 1) {
    const file = files[index];
    const newForm = new FormData();
    newForm.append("attachment", file, file.name);
    filesFromInput.push(newForm);
  }
  return filesFromInput;
}
